import React, { useState } from 'react';

import {useSelector, useDispatch} from 'react-redux';

import { Link } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import {
    AppBar,
    Button,
    CssBaseline,
    ClickAwayListener,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle,
    Divider,
    Grow,
    Grid,
    IconButton,
    ListItemText,
    makeStyles,
    MenuList,
    MenuItem,
    Paper,
    Popper,
    Tabs,
    Tab,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HelpIcon from '@mui/icons-material/Help';
import PersonIcon from '@mui/icons-material/Person';

import BugReportForm from './components/bugReportForm';

import { logoutUser } from '../../helpers/api';
import { setNavBar } from '../../redux/actions';

{/*
    This component contains the header/navigation element of the website.
    Uses a Tab Window to link multiple pages via React Router.
*/}

const useStyles = makeStyles((theme) => ({
    root:{
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        },
        "& .MuiTab-root": {
            minWidth: "72px",
            padding: "0",
            width: '18%',
            [theme.breakpoints.down('md')]: {
                width: '23%'
            },
        },
        "& .MuiTabs-flexContainer":{
            height: '100%'
        },
        "& .MuiTab-wrapper": {
            height: '100%'
        },
        "& .MuiTab-textColorPrimary.Mui-selected":{
            fontWeight: '600'
        }
    },
    appBar: {
        background : '#FFFFFF',
        [theme.breakpoints.down('xs')]: {
            background: '#a22998'
        }
    },
    icon: {
        height : '100%'
    },
    iconButton: {
        color : '#94A2AB',
        '&:hover': {
            color: '#3E6BEC'
        }
    },
    tabStyles: {
        fontWeight: '500',
        fontSize: '14px',
        fontFamily: [
            'Inter',
            'sans-serif',
        ].join(','),
        height: '100%',
        lineHeight: '21px',
        letterSpacing: '0.25px',
        textAlign: 'center',
        color: '#72808A'
    },
    logoGridItem: {
        marginTop: '0.3%',
        [theme.breakpoints.down('sm')]: {
            marginTop: '0.7%'
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '0.9%'
        },
        [theme.breakpoints.down('lg')]: {
            marginTop: '0.7%'
        },
        [theme.breakpoints.down('xl')]: {
            marginTop: '0.4%'
        }

    },
    headerTabGridItem: {
        height: '60px',
        [theme.breakpoints.down('xl')]: {
            height: '62px'
        }
    },
    toolBar: {
        minHeight: '100%'
    },
    iconGroup: {
        marginTop: '.5%',
        color: '#72808A',

        // [theme.breakpoints.down('sm')]: {
        //     marginLeft: '6%'
        // },
        [theme.breakpoints.down('xl')]: {
            marginTop: '.3%'
        },
        [theme.breakpoints.down('lg')]: {
            marginTop: '.5%',
            // marginLeft: '-4.3%'
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '1%'
        }
    },
    termsDialogText: {
        paddingRight: '15%'
    },
    termsList : {
        color: '#3E6BEC',
        '& p': {
            color: '#333333'
        }
    },
    logoutDialogButtons: {
        color: '#6a6a6a',
    },
    navTabs: {
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '5%'
        },

        [theme.breakpoints.down('sm')]: {
            paddingLeft: '5%'
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: '5%'
        }
    }
}));

function Navbar () {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = createBrowserHistory({forceRefresh:true});

    const [open, setOpen] = useState(false);
    const [openSendFeedbackDialog, setOpenSendFeedbackDialog] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const [logoutDialog, setLogoutDialog] = useState(false);
    const openHelpMenu = Boolean(anchorEl);
    const openAccountMenu = Boolean(anchorEl2);

    const navBarState = useSelector((state) => state.navBar.value);

    const handleChange = (event, newValue) => {
        dispatch(setNavBar(newValue));
        // setSelectedTab(newValue);
    };

    const handleLogout = async () => {
        await logoutUser();
        localStorage.clear();
        sessionStorage.clear();
        history.push('/login');
    }

    const handleLogoutDialog = () => {
        setLogoutDialog(true);
    }

    const handleCloseLogoutDialog = () => {
        setLogoutDialog(false);
    }

    const openTermsAndConditions = () => {
        setOpen(true);
    }

    const openSendFeedback = () => {
        setOpenSendFeedbackDialog(true);
    }

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="static"
                className={classes.appBar}
            >
                <Toolbar
                    disableGutters="true"
                    className={classes.toolBar}
                >
                    <Grid container direction="row">
                        <Grid sm={1} md={1}></Grid>
                        <Grid className={classes.logoGridItem} item xs={1}>
                            <svg width="107" height="41" viewBox="0 0 107 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.81542 10.32H9.93142V30.172H15.4474V33H5.81542V10.32Z" fill="#3E6BEC" />
                                <rect x="1" y="6" width="18" height="32" rx="1" stroke="#3E6BEC" strokeWidth="1.6" />
                                <path
                                    d="M23.82 10.32H27.908V33H23.82V10.32ZM34.6869 13.372H31.0749V10.32H42.3589V13.372H38.8309V33H34.6869V13.372ZM44.3588 10.32H47.9988L50.9948 26.364L53.8228 10.32H57.5468L52.9828 33H48.9228L44.3588 10.32ZM60.9723 10.32H65.0603V33H60.9723V10.32ZM69.5713 10.32H79.0913V13.232H73.6873V19.756H77.9433V22.64H73.6873V30.172H79.1473V33H69.5713V10.32ZM81.7358 10.32H85.1798L87.0558 25.02L89.4078 10.376H92.2078L94.6438 25.02L96.4918 10.32H99.9078L96.7438 33H93.3838L90.8638 17.796L88.3718 33H84.9278L81.7358 10.32Z"
                                    fill="#3E6BEC" />
                            </svg>
                        </Grid>
                        <Grid className={classes.headerTabGridItem} item sm={4} md={4} lg={4} container>
                            <Tabs value={navBarState} className={classes.navTabs} onChange={handleChange} indicatorColor="primary" textColor="primary">
                                <Tab className={classes.tabStyles} label="Search" component={Link} to="/search" />
                                <Tab className={classes.tabStyles} label="Projects" component={Link} to="/projects" />
                                <Tab className={classes.tabStyles} label="References" component={Link} to="/references" />
                                <Tab className={classes.tabStyles} label="Notebook" component={Link} to="/notebook" />
                            </Tabs>
                        </Grid>
                        <Grid item xs={0} sm={0} md={3} lg={4}></Grid>
                        <Grid className={classes.iconGroup} item sm={5} md={2} lg={1} justify='flex-end' container>
                            <Grid item>
                                <Tooltip title='Help Menu'>
                                    <IconButton
                                        onClick={(e) => {setAnchorEl(e.currentTarget)}}
                                        className={classes.iconButton}
                                    >
                                        <HelpIcon
                                            className={classes.icon}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Popper
                                    open={openHelpMenu}
                                    placement={'bottom'}
                                    transition
                                    onClose={(e) => setOpen(false)}
                                    anchorEl={anchorEl}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow
                                            {...TransitionProps}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={(e) => setAnchorEl(null)}>
                                                    <MenuList
                                                        autoFocus
                                                        dense
                                                        variant="filled"
                                                    >
                                                        <MenuItem onClick={(e) => openInNewTab('https://intercom.help/litview')}>
                                                            <ListItemText>
                                                                Help Center
                                                            </ListItemText>
                                                        </MenuItem>
                                                        <MenuItem onClick={(e) => openSendFeedback()}>
                                                            <ListItemText>
                                                                Send Feedback
                                                            </ListItemText>
                                                        </MenuItem>
                                                        <Divider />
                                                        <MenuItem onClick={(e) => openTermsAndConditions()}>
                                                            <ListItemText>
                                                                Terms and Conditions
                                                            </ListItemText>
                                                        </MenuItem>
                                                        <MenuItem onClick={(e) => window.location.href='/api/docs'}>
                                                            <ListItemText>
                                                                API Documentation
                                                            </ListItemText>
                                                        </MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </Grid>
                            <Grid item>
                                <Tooltip title='Account'>
                                    <IconButton
                                        onClick={(e) => {setAnchorEl2(e.currentTarget)}}
                                        className={classes.iconButton}
                                    >
                                        <PersonIcon
                                            className={classes.icon}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Popper
                                    open={openAccountMenu}
                                    placement={'bottom'}
                                    transition
                                    onClose={(e) => setOpen(false)}
                                    anchorEl={anchorEl2}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow
                                            {...TransitionProps}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={(e) => setAnchorEl2(null)}>
                                                    <MenuList
                                                        autoFocus
                                                        dense
                                                        variant="filled"
                                                    >
                                                        <MenuItem onClick={handleLogoutDialog}>
                                                            <ListItemText>
                                                                Logout
                                                            </ListItemText>
                                                        </MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </Grid>
                        </Grid>
                        <Grid item sm={1} md={1}></Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <Dialog
                open={logoutDialog}
                onClose={handleCloseLogoutDialog}
            >
                <DialogTitle>{'Confirm Logout'}</DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to log out?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogout}>
                        Yes
                    </Button>
                    <Button className={classes.logoutDialogButtons} onClick={handleCloseLogoutDialog}>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                onClose={(e) => setOpen(false)}
            >
                <DialogTitle id="alert-dialog-title">{"LitView Terms and Conditions"}</DialogTitle>
                <DialogContent className={classes.termsDialogText} dividers>
                    <ul className={classes.termsList}>
                        <li>
                            <Typography gutterBottom>
                                LitView is a research and educational tool produced and maintained by Latent Knowledge Inc. for use by company members, collaborators, or clients who utilize Latent Knowledge Inc. consulting services.
                            </Typography>
                            <Typography gutterBottom>
                                Access to PubMed is courtesy of the U.S. National Library of Medicine.
                            </Typography>
                        </li>
                        <li>
                            <Typography gutterBottom>
                                <p>LitView is not endorsed or supported by arXiv.org, although we have reached out and are seeking to become an arXivLabs collaborator.</p>
                                <p>Thank you to arXiv for use of its open access interoperability.</p>
                            </Typography>
                        </li>
                    </ul>
                </DialogContent>
            </Dialog>
            <Dialog
                open={openSendFeedbackDialog}
                onClose={(e) => setOpenSendFeedbackDialog(false)}
                maxWidth={false}
            >
                <BugReportForm />
            </Dialog>
        </div>
    );
};

export default Navbar;
